import { privateRoutes } from "constant/route/privateRoutes";
import { useAuth } from "hooks‬/Auth";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

interface PropsType {
  buttonTypeIsSubscribe?: boolean;
  havePlan?: boolean;
  productGuid?: string;
}

const SubscriptionCardButton: FC<PropsType> = ({
  buttonTypeIsSubscribe = false,
  havePlan,
  productGuid,
}) => {
  const navigate = useNavigate();
  const { companySubscriptionDetails } = useAuth();
  const canViewDetails = havePlan ?? companySubscriptionDetails?.havePlan;
  const pricingRoute = productGuid
    ? `${privateRoutes.Pricing}?Product=${productGuid}`
    : privateRoutes.Pricing;

  return (
    <>
      {canViewDetails && (
        <button
          onClick={() => navigate(privateRoutes.subscriptionUsage)}
          className="ni-dash-btn ni-dash-btn--ghost"
        >
          View details
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      )}
      <button
        onClick={() => navigate(pricingRoute)}
        className="ni-dash-btn ni-dash-btn--primary"
      >
        {buttonTypeIsSubscribe ? "Subscribe now" : "Upgrade"}
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="12" y1="19" x2="12" y2="5" />
          <polyline points="5 12 12 5 19 12" />
        </svg>
      </button>
    </>
  );
};

export default SubscriptionCardButton;
